/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Syntx_Meta_TitleInputs */

const en_syntx_meta_title = /** @type {(inputs: Syntx_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sintex AI Video Generator | Text & Image to Video`)
};

const zh_syntx_meta_title = /** @type {(inputs: Syntx_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sintex AI 视频生成器 | 文字与图片创作视频`)
};

/**
* | output |
* | --- |
* | "Sintex AI Video Generator \| Text & Image to Video" |
*
* @param {Syntx_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const syntx_meta_title = /** @type {((inputs?: Syntx_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Syntx_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_syntx_meta_title(inputs)
	return zh_syntx_meta_title(inputs)
});
export { syntx_meta_title as "syntx.meta.title" }